type optstring = string | undefined;

export class SDKConfiguration {
  private static validateStr(val: optstring): string {
    if (val === undefined) {
      throw new Error("Invalid config");
    }

    return val;
  }

  public Host: string;
  public Port: string;

  constructor(host: optstring, port: optstring) {
    this.Host = SDKConfiguration.validateStr(host);
    this.Port = SDKConfiguration.validateStr(port);
  }
}

export default new SDKConfiguration(
  process.env.REACT_APP_SEARCH_HOST,
  process.env.REACT_APP_SEARCH_PORT
);



// WEBPACK FOOTER //
// ./src/sdk/config.ts